import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/medical-record-summary-config";

export const pagingMedicalRecordSummaryType = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getMedicalRecordSummaryTypeById = (medicalRecordSummaryTypeId) => axios.get(API_PATH + "/get-by-id/" + medicalRecordSummaryTypeId);

export const saveOrUpdateMedicalRecordSummaryType = medicalRecordSummaryType => axios.post(API_PATH + "/save-or-update", medicalRecordSummaryType);

export const deleteMedicalRecordSummaryType = medicalRecordSummaryTypeId => axios.delete(API_PATH + '/mark-delete/' + medicalRecordSummaryTypeId);

export const getAllMedicalRecordSummaryType = () => axios.get(API_PATH + '/get-all');

export const getMedicalRecordConfig = (searchObject) => axios.post(API_PATH + "/get-medical-record-config", searchObject) 